module.exports = __webpack_public_path__ + "static/img/third2.cb5f43bf.png";